var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._b({staticClass:"md-list-nav"},'ul',_vm._attributes,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }